import { Container, Box, Stack, Alert, AlertTitle } from "@mui/material";
import React, { useState } from "react";
import Input from "../components/Base/Input";
import Header from "../components/common/Header";
import IntroCard from "../components/Cards/IntroCard";
import SubmitButton from "../components/common/SubmitButton";
import Note from "../components/common/Note";
import configData from "../Config";
import { useNavigate, useLocation } from "react-router-dom";
import Backdrop from "../components/common/Backdrop";
import LoadingDots from "../components/Lottie/LoadingDots";
import { apis } from "../services/apiService";
import styles from "../Style/Modules/gstReturn.module.css";
import "../Style/Theme/index.css";
import AlertPopup from "../components/common/AlertPopup";

export default function GSTreturn() {
  const navigate = useNavigate();
  let location = useLocation();
  const [disabled, setDisabled] = useState(true);
  const [files, setFiles] = useState();
  const [loading, setLoading] = useState(false);
  const [finalErr, setFinalErr] = useState("");
  let handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const reqData = {
        formfiles: (() => {
          let data;
          for (const key of Object.keys(files)) data = files[key];
          return data;
        })(),
        filetype: "GSTR",
        aid: location.state.AppId,
      };
      let resp = await apis.postWithFilesApi(
        configData.API_URL + "BRE/UploadGRTR",
        reqData
      );
      let result = await resp.json();
      if (resp?.status === 200) {
        let data = { AppId: location.state.AppId };
        navigate("/loading", { state: data });
      }
      setLoading(false);
    } catch (error) {
      const errorResult = JSON.parse(error?.message);
      setFinalErr(errorResult?.statusMessage);
      setLoading(false);
    }
  };
  const savefile = (e) => {
    if (e.target.files?.length > 0) {
      setFiles(e.target.files);
      setDisabled(false);
    } else {
      setFiles(undefined);
      setDisabled(true);
    }
  };

  const handleClosedFunk = () => {
    setFinalErr("");
  };
  return (
    <>
      <Container maxWidth={false} className="container_Th">
        <Header showBar={true} progress={"25%"} />
        <IntroCard
          title="Gst Return"
          subtitle="Please upload the GSTR-1/GSTR-3B returns of last six months."
          img="/assets/doc.svg"
        />
        <form onSubmit={handleSubmit}>
          <Box sx={{ display: "" }}>
            <Input
              type="file"
              multiple
              autoComplete="off"
              onChange={savefile}
              name="bankSt"
              id="bankStId"
              accept=".zip,application/pdf"
            />
          </Box>
          <Note
            udyamNote="udyamNote"
            note="Only files with .pdf or .zip extension allowed"
          />

          {loading && (
            <Backdrop ax="center">
              <LoadingDots />
            </Backdrop>
          )}
          {finalErr && (
            <Backdrop ax="center">
              <AlertPopup finalErr={finalErr} handleClosed={handleClosedFunk} />
              ;
            </Backdrop>
          )}
          <SubmitButton hasNote="No" disabled={disabled} />
        </form>
        <Box mb={10} className={styles.gstReturnBox}></Box>
      </Container>
    </>
  );
}
